import { createFileRoute } from "@tanstack/react-router";
import { ChangeRecord } from "@/components/companion/ChangeRecord";

export const Route = createFileRoute("/changes/$changeNumber")({
  component: ChangeDetail,
});

function ChangeDetail() {
  const { changeNumber } = Route.useParams();
  return <ChangeRecord ecnNumber={changeNumber} />;
}
